import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import {
  Card,
  CardHeader,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  CardBody,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import ReactCountryFlag from 'react-country-flag'
import { IntlContext } from '~/utility/context/Internationalization'

import loginImg from '~/assets/img/pages/login.png'
import '~/assets/scss/pages/authentication.scss'
import ForgotPasswordJWT from './components/ForgotPasswordJWT'

import Spinner from '~/components/@vuexy/spinner/Loading-spinner'
import Logo from '~/assets/img/logo/locasty-text.svg'

function ForgotPassword() {
  const [langDropdown, setLangDropdown] = useState(false)
  const [resetCodeSent, setResetCodeSent] = useState(false)
  const loading = useSelector(state => state?.auth?.loading)
  const intl = useIntl()

  const handleLangDropdown = () => setLangDropdown(prevState => !prevState)

  return (
    <Row className="m-0 justify-content-center">
      <Col
        sm="8"
        xl="7"
        lg="10"
        md="8"
        className="d-flex justify-content-center"
      >
        <Card className="bg-authentication login-card rounded-0 mb-0 w-100">
          <Row className="m-0">
            <Col
              lg="6"
              className="d-lg-block d-none text-center align-self-center px-1 py-0"
            >
              <img src={loginImg} alt="loginImg" />
            </Col>
            <Col lg="6" md="12" className="p-0">
              <LoadingIndicator loading={loading}>
                <Spinner />
              </LoadingIndicator>
              <Card className="rounded-0 mb-0 px-2 login-tabs-container">
                <LoginHeader>
                  <CardTitle>
                    <HeaderLogo src={Logo} alt="Locasty" />
                  </CardTitle>
                  <IntlContext.Consumer>
                    {context => {
                      const langArr = {
                        en: 'English',
                        br: 'Português',
                      }
                      return (
                        <Dropdown
                          tag="li"
                          className="dropdown-language nav-item ml-1"
                          isOpen={langDropdown}
                          style={{ listStyle: 'none' }}
                          toggle={handleLangDropdown}
                          data-tour="language"
                        >
                          <DropdownToggle tag="a" className="nav-link">
                            <ReactCountryFlag
                              className="country-flag"
                              countryCode={
                                context.state.locale === 'en'
                                  ? 'us'
                                  : context.state.locale
                              }
                              svg
                            />
                            <span className="d-sm-inline-block d-none text-capitalize align-middle ml-50">
                              {langArr[context.state.locale]}
                            </span>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              tag="a"
                              onClick={() => context.switchLanguage('en')}
                            >
                              <ReactCountryFlag
                                className="country-flag"
                                countryCode="us"
                                svg
                              />
                              <span className="ml-1">English</span>
                            </DropdownItem>
                            <DropdownItem
                              tag="a"
                              onClick={() => context.switchLanguage('br')}
                            >
                              <ReactCountryFlag
                                className="country-flag"
                                countryCode="br"
                                svg
                              />
                              <span className="ml-1">Português</span>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      )
                    }}
                  </IntlContext.Consumer>
                </LoginHeader>
                <p className="px-2 auth-title">
                  {intl.formatMessage({
                    id:
                      'Enter your email to start the password recovery. You will receive by email the instructions on how to access your account.',
                  })}
                </p>
                <TabContent activeTab={'1'}>
                  <TabPane tabId="1">
                    {resetCodeSent ? (
                      <CardBody className="pt-1" style={{ color: '#3D9244' }}>
                        <div
                          className="d-flex flex-row align-items-center mb-2"
                          style={{ gap: '1em' }}
                        >
                          <div>
                            <svg
                              width="27"
                              height="22"
                              viewBox="0 0 27 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M24.0003 0.302734H5.33366C3.86299 0.302734 2.66699 1.49873 2.66699 2.9694V9.63607H5.33366V5.63607L13.867 12.0361C14.1043 12.2134 14.3857 12.3027 14.667 12.3027C14.9483 12.3027 15.2297 12.2134 15.467 12.0361L24.0003 5.63607V17.6361H13.3337V20.3027H24.0003C25.471 20.3027 26.667 19.1067 26.667 17.6361V2.9694C26.667 1.49873 25.471 0.302734 24.0003 0.302734ZM14.667 9.30274L6.22168 2.96941H23.1123L14.667 9.30274Z"
                                fill="#3D9244"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 10.9697H9.33333V13.6364H0V10.9697ZM2.66663 14.9697H10.6666V17.6364H2.66663V14.9697ZM6.66663 18.9697H12V21.6364H6.66663V18.9697Z"
                                fill="#3D9244"
                              />
                            </svg>
                          </div>
                          <div>
                            {intl.formatMessage({
                              id:
                                'Instructions will be sent by email if your account exists.',
                            })}
                          </div>
                        </div>
                        <Link to="/login">
                          {intl.formatMessage({ id: 'Go Back to Login' })}
                        </Link>
                      </CardBody>
                    ) : (
                      <ForgotPasswordJWT setSuccessfull={setResetCodeSent} />
                    )}
                  </TabPane>
                </TabContent>
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

const LoginHeader = styled(CardHeader)`
  align-items: flex-start !important;
  padding-top: 40px !important;
  padding-bottom: 15px !important;
`

const LoadingIndicator = styled.div`
  display: ${({ loading }) => (loading ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 500;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;

  div {
    width: 64px;
    height: 64px;
  }
`

const HeaderLogo = styled.img`
  @media (max-width: 380px) {
    width: 150px;
  }
`

export default ForgotPassword
